const PRODUCTION_WEEK_CODE_REGEX = /^(\d{4})W(\d{2})$/i;

/** Label for MuleSoft production week (format `YYYYW{week}`, e.g. `2026W02`). */
export function formatProductionWeekLabel(
  productionDate: string | undefined | null,
): string | undefined {
  if (!productionDate?.trim()) return undefined;

  const match = PRODUCTION_WEEK_CODE_REGEX.exec(productionDate.trim());
  if (!match) return undefined;

  const year = match[1];
  const week = Number(match[2]);

  if (!Number.isInteger(week) || week < 1 || week > 53) return undefined;

  return `Semaine ${week}/${year}`;
}
